
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSleetShowersNightColour as ObiLightSleetShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-sleet-showers-night-colour.js';
 
 
 

 
 export const ObiLightSleetShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-light-sleet-showers-night-colour',
   elementClass: ObiLightSleetShowersNightColourElement,
   events: {
     
   }
  });
 
 